import filesApi from '../../api/files'

export default {
  namespaced: true,

  actions: {
    async uploadFile (props, data) {
      return await filesApi.uploadFile(data)
    },

    async getDownloadUrl (props, { key, isPublic }) {
      return await filesApi.getDownloadUrl(key, isPublic)
    }
  }
}
